module.exports = __webpack_public_path__ + "static/media/background-image2_1920x1080.dafe7d5b.jpg";